import api from './api';

const aiSceneService = {
  async list() {
    const response = await api.get('/api/ai-scenes');
    return response.data;
  },

  async get(id) {
    const response = await api.get(`/api/ai-scenes/${id}`);
    return response.data;
  },

  async getSelectableNpcs(universeId) {
    const response = await api.get('/api/ai-scenes/selectable-npcs', {
      params: { universeId },
    });
    return response.data;
  },

  async getRoleplayForums(universeId) {
    const response = await api.get('/api/ai-scenes/roleplay-forums', {
      params: { universeId },
    });
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/api/ai-scenes', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/api/ai-scenes/${id}`, payload);
    return response.data;
  },

  async regenerate(id, { feedback, fullReset } = {}) {
    const response = await api.post(`/api/ai-scenes/${id}/regenerate`, {
      feedback: feedback || undefined,
      fullReset: fullReset || false,
    });
    return response.data;
  },

  async publish(id) {
    const response = await api.post(`/api/ai-scenes/${id}/publish`);
    return response.data;
  },

  async replyDraft(id, { feedback } = {}) {
    const response = await api.post(`/api/ai-scenes/${id}/reply-draft`, {
      feedback: feedback || undefined,
    });
    return response.data;
  },

  async publishReply(id) {
    const response = await api.post(`/api/ai-scenes/${id}/publish-reply`);
    return response.data;
  },

  async abandon(id) {
    const response = await api.post(`/api/ai-scenes/${id}/abandon`);
    return response.data;
  },
};

export default aiSceneService;
